import React from "react";

export function LpplTimingBadge({ value }) {
  const cls =
    value === "Crash"
      ? "bg-red-100 text-red-700"
      : value === "Pullback"
        ? "bg-sky-100 text-sky-700"
        : "bg-slate-100 text-slate-700";
  return <span className={`inline-flex items-center h-6 px-2 rounded-full text-xs font-semibold ${cls}`}>{value}</span>;
}

export function LpplConfidenceBar({ value, label, testId }) {
  const numericValue = Number(value);
  const safeValue = Number.isFinite(numericValue) ? Math.max(0, Math.min(100, numericValue)) : 0;
  const displayValue = Number.isFinite(numericValue) ? `${Math.round(numericValue)}%` : "—";
  const barCls = safeValue >= 70 ? "bg-emerald-500" : safeValue >= 45 ? "bg-amber-500" : "bg-red-500";
  return (
    <div className="flex flex-col items-start gap-1">
      {label ? (
        <span
          data-testid={testId ? `${testId}-label` : undefined}
          className="text-[10px] uppercase tracking-wide text-slate-400"
        >
          {label}
        </span>
      ) : null}
      <div className="flex items-center gap-2" data-testid={testId ? `${testId}-bar` : undefined}>
        <div className="w-36 h-2 bg-slate-200 rounded-full overflow-hidden">
          <div className={`${barCls} h-full`} style={{ width: `${safeValue}%` }} />
        </div>
        <span
          data-testid={testId ? `${testId}-value` : undefined}
          className="text-xs font-semibold text-slate-800"
        >
          {displayValue}
        </span>
      </div>
    </div>
  );
}